import './components/sliders'
import './components/events-cards'